(function(){
  document.querySelectorAll('[data-gbb-root]').forEach(function(root){
    if(root.dataset.ready)return;
    root.dataset.ready='1';

    var dataEl=root.querySelector('[data-gbb-data]'),data;

    try{
      data=JSON.parse(dataEl.textContent);
    }catch(e){
      console.error('Gift box builder JSON error',e);
      return;
    }

    var settings=data.settings||{};
    var copy=settings.copy||{};
    var steps=data.steps||['Select Gift Box','Select Products','Message Card','Write Message'];

    var tiers=(data.discountTiers||[])
      .filter(function(t){return +t.threshold>0&&+t.percent>0})
      .sort(function(a,b){return a.threshold-b.threshold});

    var money=new Intl.NumberFormat('en-AU',{
      style:'currency',
      currency:settings.currency||'AUD'
    });

    var catalog={
      box:norm(data.giftBox),
      products:(data.products||[]).map(norm).filter(Boolean),
      cards:(data.cards||[]).map(norm).filter(Boolean)
    };

    var n={
      steps:root.querySelector('[data-gbb-steps]'),
      screen:root.querySelector('[data-gbb-screen]'),
      count:root.querySelector('[data-gbb-count]'),
      discount:root.querySelector('[data-gbb-discount]'),
      trayItems:root.querySelector('[data-gbb-tray-items]'),
      total:root.querySelector('[data-gbb-total]'),
      modal:root.querySelector('[data-gbb-modal]'),
      loading:root.querySelector('[data-gbb-loading]'),
      loadingLabel:root.querySelector('[data-gbb-loading-label]'),
      loadingVisual:root.querySelector('[data-gbb-loading-visual]'),
      toast:root.querySelector('[data-gbb-toast]')
    };

    var state={
      step:0,
      review:false,
      search:'',
      filter:'All',
      sort:'featured',
      lines:[],
      message:{to:'',from:'',body:''},
      messageBlankConfirmed:false,
      submittedBundleId:'',
      submittedInCart:false,
      modal:{product:null,group:'',qty:1,options:[],img:0}
    };

    // Occasion-specific entry links: ?occasion=birthday, ?occasion=new-puppy, etc.
    // The URL only sets the initial greeting-card filter; visitors can choose All occasions.
    var occasionAliases={
      'birthday':'Birthday','dog-birthday':'Birthday','barkday':'Birthday',
      'new-puppy':'New dog','puppy':'New dog','new-dog':'New dog',
      'christmas':'Christmas','xmas':'Christmas',
      'thinking-of-you':'Just because',
      'thank-you':'Thank you','thanks':'Thank you',
      'congratulations':'Congratulations','congrats':'Congratulations',
      'mum':'Mum','dog-mum':'Mum','mom':'Mum',
      'dad':'Dad','dog-dad':'Dad',
      'love-you':'Love you','anniversary':'Anniversary',
      'get-well':'Get well soon','get-well-soon':'Get well soon',
      'easter':'Easter','retirement':'Retirement',
      'sorry':"I'm sorry",'good-luck':'Good luck',
      'holidays':'Holidays','seasons-greetings':'Seasons Greetings',
      'miss-you':'Miss you','just-because':'Just because'
    };
    var occasionParam=new URLSearchParams(window.location.search).get('occasion');
    var entryOccasion=occasionAliases[String(occasionParam||'').toLowerCase().trim()]||'';

    var storageKey='ddGiftBoxBuilder:'+location.pathname+':'+(root.id||'default');
    var storageMaxAge=24*60*60*1000;

    var loadingTimer=null;
    var loadingDelayTimer=null;
    var cartSubmitting=false;
    var cartEditing=false;
    var historyStateKey='gbb-'+Date.now()+'-'+Math.random().toString(36).slice(2);
    var ignoreNextPopstate=false;

var loadingSequence=[
  0,1,2,3,4,5,
  5,5,
  4,3,2,1,0
];

var preparingFrames=Array.isArray(settings.preparingFrames)
  ? settings.preparingFrames.filter(Boolean)
  : [];

/* Preload all frames so the animation does not flash or jump. */
preparingFrames.forEach(function(src){
  var image=new Image();
  image.src=src;
});

    loadSavedState();
    if(state.step===2&&!state.review&&entryOccasion){
      state.filter=entryOccasion;
    }
    render();
    replaceBuilderHistory(false);

    root.addEventListener('click',click);
    root.addEventListener('input',input);
    root.addEventListener('change',change);

    window.addEventListener('pageshow',function(){
      window.clearTimeout(loadingDelayTimer);
      loadingDelayTimer=null;
      cartSubmitting=false;
      cartEditing=false;
      loading(false);
      verifySubmittedBundle();
    });

    window.addEventListener('popstate',function(event){
      if(ignoreNextPopstate){
        ignoreNextPopstate=false;
        return;
      }

      var historyState=event.state||{};

      if(historyState.gbbKey!==historyStateKey){
        return;
      }

      if(n.modal&&n.modal.classList.contains('is-open')){
        closeModal(true);
        return;
      }

      state.step=Math.max(0,Math.min(3,+historyState.gbbStep||0));
      state.review=!!historyState.gbbReview;
      resetSearch();
      render();
      top();
    });

    function render(){
      renderSteps();

      if(state.review){
        renderReview();
      }else if(state.step===0){
        renderBox();
      }else if(state.step===1){
        renderProducts();
      }else if(state.step===2){
        renderCards();
      }else{
        renderMessage();
      }

      renderTray();
      updateTrayNextButton();
      saveState();
    }

    function renderSteps(){
      var map=[0,33.333,66.666,100];
      n.steps.style.setProperty('--gbb-step-progress',map[state.step]+'%');

      n.steps.innerHTML=steps.map(function(s,i){
        var complete=i<state.step;
        var active=i===state.step&&!state.review;

        return '<button type="button" class="gbb__step '+(complete?'is-complete ':'')+(active?'is-active':'')+'" data-gbb-step="'+i+'"><span class="gbb__step-icon">'+(complete?'✓':['□','▧','▣','✎'][i])+'</span><span class="gbb__step-title">'+esc(s)+'</span></button>';
      }).join('');
    }

    function renderBox(){
      n.screen.innerHTML=
        '<div class="gbb__hero">'+
          (settings.heroImage
            ? '<img src="'+attr(settings.heroImage)+'" alt="'+attr(copy.heroTitle||'The Gift Box Builder')+'">'
            : '<div class="gbb__hero-fallback">'+esc(copy.heroTitle||'The Gift Box Builder')+'</div>'
          )+
        '</div>'+
        '<p class="gbb__intro">'+esc(copy.boxIntro||'')+'</p>'+
        '<div class="gbb__grid gbb__grid--box">'+
          (catalog.box
            ? card(catalog.box,'box')
            : '<div class="gbb__empty">Choose a gift box product in the theme editor.</div>'
          )+
        '</div>';
    }

    function renderProducts(){
      var items=prep(catalog.products);
      var cats=categories(catalog.products);

      n.screen.innerHTML=
        '<p class="gbb__intro">'+esc(copy.productsIntro||'')+'</p>'+
        toolbar(cats)+
        '<div class="gbb__grid">'+
          (items.length?items.map(function(p){return card(p,'product')}).join(''):empty())+
        '</div>';
    }

    function renderCards(){
      var items=prep(catalog.cards);
      var cats=categories(catalog.cards);

      n.screen.innerHTML=
        '<p class="gbb__intro">'+esc(copy.cardsIntro||'')+'</p>'+
        toolbar(cats)+
        '<div class="gbb__grid">'+
          (items.length?items.map(function(p){return card(p,'card')}).join(''):empty())+
        '</div>';
    }

    function renderMessage(){
      var hasMessage=String(state.message.body||'').trim().length>0;

      n.screen.innerHTML=
        '<style>'+
          '#'+root.id+' .gbb__message-form{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1.15fr);grid-template-areas:"to message" "from message" "blank blank";gap:16px 18px;align-items:stretch;max-width:960px;margin:28px auto 0}'+
          '#'+root.id+' .gbb__message-to{grid-area:to}'+
          '#'+root.id+' .gbb__message-from{grid-area:from}'+
          '#'+root.id+' .gbb__message-body{grid-area:message;min-height:100%;height:100%;resize:vertical}'+
          '#'+root.id+' [data-gbb-blank-wrap]{grid-area:blank;margin-top:0!important}'+
          '#'+root.id+' .gbb__message-form input,#'+root.id+' .gbb__message-form textarea{width:100%;box-sizing:border-box}'+
          '@media(max-width:749px){'+
            '#'+root.id+' .gbb__message-form{grid-template-columns:1fr;grid-template-areas:"to" "message" "from" "blank";gap:12px;margin-top:20px}'+
            '#'+root.id+' .gbb__message-body{min-height:150px;height:auto}'+
          '}'+
        '</style>'+
        '<p class="gbb__intro">'+esc(copy.messageIntro||'')+'</p>'+
        '<div class="gbb__message-form">'+
          '<input class="gbb__message-to" data-gbb-message="to" placeholder="'+attr(copy.to||'To')+'" value="'+attr(state.message.to)+'">'+
          '<textarea class="gbb__message-body" data-gbb-message="body" placeholder="'+attr(copy.messagePlaceholder||'Enter a message here...')+'">'+esc(state.message.body)+'</textarea>'+
          '<input class="gbb__message-from" data-gbb-message="from" placeholder="'+attr(copy.from||'From')+'" value="'+attr(state.message.from)+'">'+
          '<div data-gbb-blank-wrap '+(hasMessage?'hidden':'')+' style="padding:13px 15px;border:1px solid rgba(7,61,89,.16);border-radius:10px;background:#f8fbfd">'+
            '<label style="display:flex;align-items:center;gap:10px;margin:0;color:var(--gbb-blue);font-weight:800;cursor:pointer">'+
              '<input type="checkbox" data-gbb-blank-message '+(state.messageBlankConfirmed?'checked':'')+' style="width:18px;height:18px;margin:0;accent-color:var(--gbb-blue)">'+
              '<span>Leave gift message blank</span>'+
            '</label>'+
            '<p style="margin:7px 0 0 28px;font-size:13px;line-height:1.4;color:#496b7d">Tick this if you don\'t want to include a message.</p>'+
          '</div>'+
        '</div>';
    }

    function renderReview(){
      var lines=cartLines();
      var p=pricing();
      var box=lines.find(function(l){return l.group==='box'})||lines[0];
      var giftMessageHtml='';
      var cartButtonLabel=state.submittedInCart
        ? 'Return to Cart'
        : (copy.addToCart||'Add To Cart');
      var reviewHeaderActions=state.submittedInCart
        ? ''
        : '<div><button class="gbb__link" data-gbb-edit type="button">'+esc(copy.edit||'Edit')+'</button> <button class="gbb__link gbb__danger" data-gbb-reset type="button">'+esc(copy.remove||'Remove')+'</button></div>';
      var inCartNotice=state.submittedInCart
        ? '<div class="gbb__empty" data-gbb-notice>This gift box is already in your cart. To change it, choose Edit This Gift Box. It will be removed from the cart while you make your changes.</div>'
        : '<div class="gbb__empty" data-gbb-notice hidden></div>';

      if(state.message.to||state.message.from||state.message.body||state.messageBlankConfirmed){
        giftMessageHtml=
          '<div class="gbb__review-message">'+
            '<h3>Gift Message</h3>'+
            (state.message.to ? '<p><strong>To:</strong> '+esc(state.message.to)+'</p>' : '')+
            (state.message.from ? '<p><strong>From:</strong> '+esc(state.message.from)+'</p>' : '')+
            (state.message.body
              ? '<p><strong>Message:</strong> '+esc(state.message.body)+'</p>'
              : (state.messageBlankConfirmed ? '<p><strong>Message:</strong> Intentionally left blank</p>' : ''))+
          '</div>';
      }

var reviewItemCount=lines.reduce(function(s,l){
  var group=(l.group||'').toString().toLowerCase();

  if(group.indexOf('box')>-1){
    return s;
  }

  return s+(+l.qty||1);
},0);

var reviewItemLabel=reviewItemCount===1?'Item':'Items';

      n.screen.innerHTML=
        '<div class="gbb__review">'+
          '<h1>'+esc(copy.reviewTitle||'')+'</h1>'+
          '<p class="gbb__review-copy">'+esc(copy.reviewCopy||'')+'</p>'+
          '<div class="gbb__review-layout">'+
            '<div class="gbb__review-box">'+
              '<div class="gbb__review-head">'+
                img(box,'gbb__review-img')+
                '<div><h2 style="margin:0;color:var(--gbb-blue);font-size:17px;font-weight:900">GIFT BOX BUILDER <span>'+reviewItemCount+' '+reviewItemLabel+'</span></h2></div>'+
                reviewHeaderActions+
              '</div>'+
              '<div class="gbb__review-lines">'+
                lines.map(function(l){
                  return '<div class="gbb__review-line"><span>'+esc(lineTitle(l))+'</span><strong>'+fmt(l.price)+'</strong><span>x'+l.qty+'</span></div>';
                }).join('')+
              '</div>'+
              giftMessageHtml+
            '</div>'+
            '<div class="gbb__order-box">'+
              '<h2 style="margin:0 0 18px;color:var(--gbb-blue);font-size:16px">'+esc(copy.orderDetails||'Order Details')+'</h2>'+
              '<div class="gbb__order-row"><span>'+esc(copy.subtotal||'Subtotal')+'</span><strong>'+fmt(p.subtotal)+'</strong></div>'+
              (p.discount>0 ? '<div class="gbb__order-row gbb__order-row--saving"><span>Gift Box Saving</span><strong>-'+fmt(p.discount)+'</strong></div>' : '')+
              '<div class="gbb__order-row"><span>'+esc(copy.total||'Total')+'</span><strong>'+fmt(p.total)+'</strong></div>'+
              '<button class="gbb__primary gbb__primary--complete" data-gbb-cart type="button" '+(cartEditing?'disabled':'')+'>'+(state.submittedInCart?'':'✓ ')+esc(cartButtonLabel)+'</button>'+
              (state.submittedInCart
                ? '<button class="gbb__secondary" data-gbb-edit-cart type="button" '+(cartEditing?'disabled':'')+'>'+(cartEditing?'Preparing Edit...':'Edit This Gift Box')+'</button>'
                : ''
              )+
              '<button class="gbb__secondary" data-gbb-reset type="button" '+(cartEditing?'disabled':'')+'>'+esc(copy.createNewBox||'Create new Box')+'</button>'+
              inCartNotice+
            '</div>'+
          '</div>'+
        '</div>';
    }

    function toolbar(cats){
      if(state.step===1){
        return '<div class="gbb__toolbar gbb__toolbar--no-search">'+
          productTypeSelectMarkup()+
        '</div>';
      }

      if(state.step===2){
        return '<div class="gbb__toolbar gbb__toolbar--no-search">'+
          '<select class="gbb__filter-select" data-gbb-filter-select>'+
            '<option value="All" '+(state.filter==='All'?'selected':'')+'>'+esc('All occasions')+'</option>'+
            cats.filter(function(c){return c!=='All'}).map(function(c){
              return '<option value="'+attr(c)+'" '+(state.filter===c?'selected':'')+'>'+esc(c)+'</option>';
            }).join('')+
          '</select>'+
        '</div>';
      }

      return '';
    }

    function productTypeSelectMarkup(){
      var current=state.filter||'All';

      function option(value,label){
        return '<option value="'+attr(value)+'" '+(current===value?'selected':'')+'>'+esc(label)+'</option>';
      }

      return '<select class="gbb__filter-select" data-gbb-filter-select>'+
        option('All','All Products')+
        '<optgroup label="— DOG —">'+
          option('Dog Towels','Dog Towels')+
          option('Dog Drying Robes','Dog Drying Robes')+
          option('Dog Hoodies & Jumpers','Dog Hoodies & Jumpers')+
          option('Dog Treats','Dog Treats')+
        '</optgroup>'+
        '<optgroup label="— HUMAN —">'+
          option('Adult Hooded Towels','Adult Hooded Towels')+
          option('Kids & Toddler Hooded Towels','Kids & Toddler Hooded Towels')+
        '</optgroup>'+
        '<optgroup label="— FEATURED —">'+
          option('Matching Dog & Owner Sets','Matching Dog & Owner Sets')+
        '</optgroup>'+
      '</select>';
    }

    function sel(v){
      return state.sort===v?'selected':'';
    }

    function card(p,group){
      var v=firstVar(p);
      var image=p.featuredImage||(v&&v.image);
      var disabled=
        settings.trackInventory&&
        !productHasAvailableVariant(p);
      var selected=state.lines.some(function(l){
        return l.group===group&&l.productId===p.id;
      });

      var selectedText=copy.added||'Added';
      var groupKey=(group||'').toString().toLowerCase();

      if(selected){
        if(groupKey.indexOf('product')>-1){
          selectedText='Add Another';
        }else if(groupKey.indexOf('box')>-1||groupKey.indexOf('card')>-1){
          selectedText='✓ Selected';
        }
      }

      var text=disabled
        ? (copy.noMoreStock||'No More Stock')
        : (selected
            ? selectedText
            : (hasOptions(p)
                ? (copy.chooseOptions||'Choose Options')
                : (copy.addToBox||'Add To Box')
              )
          );

      return '<article class="gbb__card" data-gbb-open-product data-gbb-open-group="'+group+'" data-gbb-product="'+p.id+'">'+
        '<div class="gbb__card-img">'+
          (image
            ? '<img src="'+attr(image)+'" alt="'+attr(p.title)+'" loading="lazy">'
            : '<div class="gbb__fallback">'+esc(p.title)+'</div>'
          )+
        '</div>'+
        '<h2 class="gbb__title">'+esc(p.title)+'</h2>'+
        '<div class="gbb__price">'+
          (v&&v.compareAt&&v.compareAt>v.price?'<span class="gbb__compare">'+fmt(v.compareAt)+'</span>':'')+
          '<span>'+fmt(v?v.price:p.price)+'</span>'+
        '</div>'+
        '<button type="button" class="gbb__soft" data-gbb-action="'+group+'" data-gbb-product="'+p.id+'" '+(disabled?'disabled':'')+'>'+esc(text)+'</button>'+
      '</article>';
    }

    function renderTray(){
      var lines=cartLines();
      var p=pricing();
      var hideCount=state.step===0&&!state.review;

      n.count.hidden=hideCount;
      n.count.setAttribute('aria-hidden',hideCount?'true':'false');

      n.count.textContent=lines.reduce(function(s,l){
        var group=(l.group||'').toString().toLowerCase();

        if(group.indexOf('box')>-1){
          return s;
        }

        return s+(+l.qty||1);
      },0);

      n.total.innerHTML=
        '<span class="gbb__total-price">'+fmt(p.total)+'</span>'+
        (p.discount>0
          ? '<span class="gbb__total-save">'+p.percent+'% off · Saving '+fmt(p.discount)+'</span>'
          : ''
        );

      var trayMessage='';

      if(state.submittedInCart){
        trayMessage='This gift box is already in your cart.';
      }else if(state.review){
        trayMessage=p.eligible>0 ? discountMsg(p.eligible) : 'Review your gift box.';
      }else if(state.step===0){
        trayMessage='Choose your gift box, then fill it with gifts.';
      }else if(state.step===1){
        trayMessage=p.eligible>0 ? discountMsg(p.eligible) : 'Add gifts to unlock bundle savings.';
      }else if(state.step===2){
        trayMessage='Choose a card to make it personal.';
      }else if(state.step===3){
        trayMessage='Write your message, then review your gift box.';
      }else{
        trayMessage=discountMsg(p.eligible);
      }

      n.discount.innerHTML=
        esc(trayMessage)+
        '<div class="gbb__bar"><span style="--p:'+progress(p.eligible)+'%"></span></div>';

      n.trayItems.innerHTML=lines.map(function(l,index){
        var removeButton='';

        if(l.group!=='box'&&!state.submittedInCart){
          removeButton=
            '<button type="button" class="gbb__tray-remove" data-gbb-remove-tray="'+index+'" aria-label="Remove '+attr(lineTitle(l))+'">&times;</button>';
        }

        return '<div class="gbb__tray-item gbb__tray-line">'+
          removeButton+
          img(l,'')+
          '<div><strong>'+esc(trunc(lineTitle(l),32))+'</strong><br>'+fmt(l.price)+' x'+l.qty+'</div>'+
        '</div>';
      }).join('');

      var trayInner=n.trayItems.closest('.gbb__tray-inner');

      if(trayInner){
        var oldHint=trayInner.querySelector('[data-gbb-tray-swipe-hint]');

        if(oldHint){
          oldHint.remove();
        }

        trayInner.classList.remove('gbb__tray-inner--scrollhint','gbb__tray-inner--hint-hidden');
        trayInner.style.removeProperty('--gbb-swipe-hint-top');

        requestAnimationFrame(function(){
          if(!n.trayItems||!trayInner)return;

          var canScroll=n.trayItems.scrollWidth>n.trayItems.clientWidth+8;

          if(lines.length>=3){
            trayInner.style.setProperty(
              '--gbb-swipe-hint-top',
              (n.trayItems.offsetTop+(n.trayItems.offsetHeight/2))+'px'
            );

            trayInner.classList.add('gbb__tray-inner--scrollhint');
          }
        });
      }

      if(n.trayItems&&!n.trayItems.dataset.gbbSwipeHintBound){
        n.trayItems.dataset.gbbSwipeHintBound='true';

        n.trayItems.addEventListener('scroll',function(){
          if(this.scrollLeft>4){
            var inner=this.closest('.gbb__tray-inner');

            if(inner){
              inner.classList.add('gbb__tray-inner--hint-hidden');
            }
          }
        },{passive:true});
      }
    }

    function updateTrayNextButton(){
      var button=root.querySelector('[data-gbb-next]');

      if(!button)return;

      if(!button.getAttribute('data-gbb-next-label')){
        button.setAttribute('data-gbb-next-label',(button.textContent||'Next').trim()||'Next');
      }

      var nextLabel=button.getAttribute('data-gbb-next-label')||'Next';
      var completeLabel=button.getAttribute('data-gbb-complete-label')||'✓ Add To Cart';

      if(state.review){
        button.classList.add('gbb__nav--complete');
        button.textContent=state.submittedInCart?'Return to Cart':completeLabel;
        button.setAttribute('aria-label',state.submittedInCart?'Return to Cart':'Add To Cart');
      }else{
        button.classList.remove('gbb__nav--complete');
        button.textContent=nextLabel;
        button.setAttribute('aria-label',nextLabel);
      }
    }

    function removeTrayLine(index){
      index=parseInt(index,10);
      if(isNaN(index))return;

      var lines=cartLines();
      var line=lines[index];

      if(!line)return;
      if(line.group==='box')return;

      state.lines=state.lines.filter(function(item){
        return item!==line;
      });

      if(line.group==='card'){
        state.message={
          to:'',
          from:'',
          body:''
        };
        state.messageBlankConfirmed=false;
      }

      render();

      if(typeof toast==='function'){
        toast('Removed from gift box.');
      }
    }

    function click(e){
      var el;

      if(el=e.target.closest('[data-gbb-size-guide-open]')){
        e.preventDefault();
        openBuilderSizeGuide(state.modal.product);
        return;
      }

      if(el=e.target.closest('[data-gbb-size-guide-close]')){
        e.preventDefault();
        closeBuilderSizeGuide();
        return;
      }

      if(el=e.target.closest('[data-gbb-size-guide-calc]')){
        e.preventDefault();
        calculateBuilderSize();
        return;
      }

      if(e.target.hasAttribute&&e.target.hasAttribute('data-gbb-size-guide-overlay')){
        closeBuilderSizeGuide();
        return;
      }

      if(el=e.target.closest('[data-gbb-remove-tray]')){
        e.preventDefault();
        e.stopPropagation();

        if(state.submittedInCart){
          toast('This gift box is already in your cart. Choose Create new Box to make another.');
          return;
        }

        removeTrayLine(el.getAttribute('data-gbb-remove-tray'));
        return;
      }

      if(el=e.target.closest('[data-gbb-step]')){
        if(state.submittedInCart){
          toast('This gift box is already in your cart. Choose Create new Box to make another.');
          return;
        }

        var i=+el.dataset.gbbStep;

        if(i<=state.step||canForward(true)){
          state.step=i;
          state.review=false;
          resetSearch();
          replaceBuilderHistory(false);
          render();
          top();
        }
      }

      if(el=e.target.closest('[data-gbb-open-product]')){
        if(!e.target.closest('[data-gbb-action]')){
          var openGroup=el.dataset.gbbOpenGroup;
          var openProduct=find(el.dataset.gbbProduct,openGroup);

          if(openProduct){
            openModal(openProduct,openGroup);
            return;
          }
        }
      }

      if(el=e.target.closest('[data-gbb-action]')){
        var group=el.dataset.gbbAction;
        var p=find(el.dataset.gbbProduct,group);

        if(!p)return;

        hasOptions(p)?openModal(p,group):addSimple(p,group);
      }

      if(e.target.closest('[data-gbb-back]')){
        if(state.submittedInCart){
          location.href='/cart';
          return;
        }

        back();
        return;
      }

      if(e.target.closest('[data-gbb-next]')){
        if(state.review){
          addToCart();
        }else{
          forward();
        }

        return;
      }

      if(e.target.closest('[data-gbb-close]')||e.target===n.modal){
  e.preventDefault();
  e.stopPropagation();

  closeModal(true);
  replaceBuilderHistory(false);
  return;
}

      if(el=e.target.closest('[data-gbb-qty]')){
        if(state.modal.group!=='product')return;

        state.modal.qty=Math.max(1,state.modal.qty+(+el.dataset.gbbQty));
        renderModal();
      }

      if(el=e.target.closest('[data-gbb-option]')){
        if(el.disabled||el.getAttribute('aria-disabled')==='true'){
          return;
        }

        state.modal.options[+el.dataset.gbbOption]=el.dataset.gbbValue;
        renderModal();
      }

      if(el=e.target.closest('[data-gbb-modal-add]')){
  e.preventDefault();
  e.stopPropagation();
  addModal();
  return;
}

      if(el=e.target.closest('[data-gbb-thumb]')){
        state.modal.img=+el.dataset.gbbThumb;
        renderModal();
      }

      if(e.target.closest('[data-gbb-edit-cart]')){
        editSubmittedBundle();
        return;
      }

      if(e.target.closest('[data-gbb-edit]')){
        if(state.submittedInCart){
          toast('This gift box is already in your cart. Choose Edit This Gift Box to change it.');
          return;
        }

        state.review=false;
        state.step=0;
        resetSearch();
        replaceBuilderHistory(false);
        render();
        top();
      }

      if(e.target.closest('[data-gbb-reset]')){
        if(cartEditing)return;
        reset();
      }

      if(e.target.closest('[data-gbb-cart]')){
        addToCart();
      }
    }

    function input(e){
      var el;

      if(el=e.target.closest('[data-gbb-message]')){
        var field=el.dataset.gbbMessage;
        state.message[field]=el.value;

        if(field==='body'){
          var hasMessage=String(el.value||'').trim().length>0;
          var wrap=root.querySelector('[data-gbb-blank-wrap]');
          var checkbox=root.querySelector('[data-gbb-blank-message]');

          state.messageBlankConfirmed=false;

          if(checkbox){
            checkbox.checked=false;
          }

          if(wrap){
            wrap.hidden=hasMessage;
            wrap.style.borderColor='rgba(7,61,89,.16)';
          }
        }

        saveState();
      }
    }

    function change(e){
      var el;

      if(el=e.target.closest('[data-gbb-blank-message]')){
        state.messageBlankConfirmed=!!el.checked;

        var wrap=root.querySelector('[data-gbb-blank-wrap]');
        if(wrap){
          wrap.style.borderColor='rgba(7,61,89,.16)';
        }

        saveState();
        return;
      }

      if(el=e.target.closest('[data-gbb-sort]')){
        state.sort=el.value;
        renderPartial();
        saveState();
        return;
      }

      if(el=e.target.closest('[data-gbb-filter-select]')){
        state.filter=el.value||'All';
        renderPartial();
        saveState();
        return;
      }
    }

    function renderPartial(){
      state.step===1?renderProducts():state.step===2?renderCards():render();
    }

    function openModal(p,group){
      var v=firstVar(p);

      state.modal={
        product:p,
        group:group,
        qty:1,
        options:modalOptionValues(p,v),
        img:0
      };

      pushBuilderHistory(true);
      renderModal();
      n.modal.classList.add('is-open');
      n.modal.setAttribute('aria-hidden','false');

      setTimeout(function(){
        var panel=n.modal.querySelector('.gbb__modal');
        var inner=n.modal.querySelector('.gbb__modal-inner');

        if(panel)panel.scrollTop=0;
        if(inner)inner.scrollTop=0;
        n.modal.scrollTop=0;
      },0);
    }

    function closeModal(fromHistory){
      var shouldStepBack=
        !fromHistory&&
        window.history&&
        window.history.state&&
        window.history.state.gbbKey===historyStateKey&&
        window.history.state.gbbModal===true;

      n.modal.classList.remove('is-open');
      n.modal.setAttribute('aria-hidden','true');
      state.modal.product=null;
      closeBuilderSizeGuide();

      if(shouldStepBack){
        ignoreNextPopstate=true;
        window.history.back();
      }
    }

    function renderModal(){
      var p=state.modal.product;

      if(!p)return;

      if(state.modal.group!=='product'){
        state.modal.qty=1;
      }

      var v=selectedVar(p);
      var images=modalImages(p,v);
      var imgUrl=images[state.modal.img]||p.featuredImage||'';
      var mi=root.querySelector('[data-gbb-modal-image]');

      mi.src=imgUrl;
      mi.hidden=!imgUrl;

      root.querySelector('[data-gbb-modal-title]').textContent=p.title;

      var priceEl=root.querySelector('[data-gbb-modal-price]');

      priceEl.innerHTML=
        (v&&v.compareAt&&v.compareAt>v.price?'<span class="gbb__compare">'+fmt(v.compareAt)+'</span> ':'')+
        '<span>'+fmt(v?v.price:p.price)+'</span>';

      root.querySelectorAll('.gbb__size-guide,.gbb__modal-description').forEach(function(el){
        el.remove();
      });

      if(needsSizeGuide(p)){
        priceEl.insertAdjacentHTML(
          'afterend',
          '<button type="button" class="gbb__size-guide" data-gbb-size-guide-open>← Find My Size</button>'
        );
      }

      setQuantityVisibility(state.modal.group==='product');

      root.querySelector('[data-gbb-thumbs]').innerHTML=images.map(function(x,i){
        return '<button class="gbb__thumb '+(i===state.modal.img?'is-active':'')+'" type="button" data-gbb-thumb="'+i+'"><img src="'+attr(x)+'" alt=""></button>';
      }).join('');

      root.querySelector('[data-gbb-options]').innerHTML=optionEntries(p).map(function(entry,i){
        var o=entry.option;

        return '<div class="gbb__option">'+
          '<span class="gbb__option-label">'+esc(o.name)+'</span>'+
          '<div class="gbb__swatches">'+
            o.values.map(function(val){
              var soldOut=
                settings.trackInventory&&
                !optionValueAvailable(p,i,val);

              var active=state.modal.options[i]===val;

              return '<button type="button" '+
                'class="gbb__swatch '+(active?'is-active ':'')+(soldOut?'is-sold-out':'')+'" '+
                'data-gbb-option="'+i+'" '+
                'data-gbb-value="'+attr(val)+'" '+
                (soldOut
                  ? 'disabled aria-disabled="true" aria-label="'+attr(val+' — Sold out')+'" title="Sold out"'
                  : ''
                )+
                '>'+
                (soldOut
                  ? '<span style="text-decoration:line-through;opacity:.58">'+esc(val)+'</span><span aria-hidden="true"> — Sold out</span>'
                  : esc(val)
                )+
              '</button>';
            }).join('')+
          '</div>'+
        '</div>';
      }).join('');

      var addBtn=root.querySelector('[data-gbb-modal-add]');

      if(addBtn){
        if(!addBtn.dataset.gbbAvailableLabel){
          addBtn.dataset.gbbAvailableLabel=
            (addBtn.textContent||copy.addToBox||'Add To Box').trim();
        }

        var selectionUnavailable=
          !v||
          (
            settings.trackInventory&&
            !available(v)
          );

        addBtn.disabled=selectionUnavailable;
        addBtn.setAttribute(
          'aria-disabled',
          selectionUnavailable?'true':'false'
        );

        addBtn.textContent=selectionUnavailable
          ? 'Sold out'
          : addBtn.dataset.gbbAvailableLabel;
      }

      var modalDescriptionHtml=
        p.builderDescriptionHtml||
        p.descriptionHtml||
        (p.description?'<p>'+esc(p.description)+'</p>':'');

      if(addBtn&&modalDescriptionHtml){
        addBtn.insertAdjacentHTML(
          'afterend',
          '<div class="gbb__modal-description">'+
            modalDescriptionHtml+
          '</div>'
        );
      }
    }

    function setQuantityVisibility(show){
      var qtyValue=root.querySelector('[data-gbb-qty-value]');

      if(qtyValue){
        qtyValue.textContent=state.modal.qty;
      }

      var qtyButtons=root.querySelectorAll('[data-gbb-qty]');

      qtyButtons.forEach(function(btn){
        btn.style.display=show?'':'none';
      });

      if(qtyValue){
        var box=qtyValue.parentElement;
        var count=0;

        while(box&&box!==root&&count<5){
          var text=String(box.textContent||'').toLowerCase();
          var hasQtyControls=
            box.querySelector('[data-gbb-qty]')||
            box.querySelector('[data-gbb-qty-value]');

          if(hasQtyControls&&text.indexOf('quantity')>-1){
            box.style.display=show?'':'none';
            return;
          }

          box=box.parentElement;
          count++;
        }

        var fallback=qtyValue.closest('.gbb__qty')||qtyValue.parentElement;

        if(fallback){
          fallback.style.display=show?'':'none';
        }
      }
    }

    function needsSizeGuide(p){
      return !!(p&&p.sizeGuide&&p.sizeGuide.contentHtml);
    }

    function openBuilderSizeGuide(p){
      var existing=root.querySelector('[data-gbb-size-guide-overlay]');

      if(existing){
        existing.remove();
      }

      var markup=builderSizeGuideMarkup(p);

      if(!markup){
        toast('Size guide is not available for this product.');
        return;
      }

      root.insertAdjacentHTML('beforeend',markup);

      existing=root.querySelector('[data-gbb-size-guide-overlay]');
      existing.classList.add('is-open');
      existing.setAttribute('aria-hidden','false');
    }

    function closeBuilderSizeGuide(){
      var existing=root.querySelector('[data-gbb-size-guide-overlay]');

      if(!existing)return;

      existing.classList.remove('is-open');
      existing.setAttribute('aria-hidden','true');
    }

    function builderSizeGuideMarkup(p){
      if(!p||!p.sizeGuide||!p.sizeGuide.contentHtml)return '';

      var showRobeCalculator=isDogRobeSizeGuide(p);

      return ''+
        '<div class="gbb__size-guide-overlay" data-gbb-size-guide-overlay aria-hidden="true">'+
          '<div class="gbb__size-guide-panel" role="dialog" aria-modal="true">'+
            '<button type="button" class="gbb__size-guide-close" data-gbb-size-guide-close aria-label="Close size guide">&times;</button>'+
            '<h2>'+esc(p.sizeGuide.title||'Size Guide')+'</h2>'+

            (showRobeCalculator
              ? '<div class="gbb__size-guide-calculator">'+
                  '<p>Measure from the base of your dog’s neck to the base of their tail.</p>'+
                  '<img class="gbb__size-guide-measure-img" src="https://cdn.shopify.com/s/files/1/0496/0390/3637/files/Size-Guide-For-Dog-Robe-image.jpg?v=1764283741" alt="Dog measuring guide" loading="lazy">'+
                  '<div class="gbb__size-guide-calc">'+
                    '<input type="number" inputmode="decimal" data-gbb-size-guide-input placeholder="Dog length in cm">'+
                    '<button type="button" data-gbb-size-guide-calc>Calculate</button>'+
                  '</div>'+
                  '<div class="gbb__size-guide-result" data-gbb-size-guide-result hidden></div>'+
                '</div>'
              : ''
            )+

            '<div class="gbb__size-guide-page-content">'+p.sizeGuide.contentHtml+'</div>'+
          '</div>'+
        '</div>';
    }

    function isDogRobeSizeGuide(p){
      if(!p||!p.sizeGuide)return false;

      var guideText=[
        p.sizeGuide.title||'',
        p.sizeGuide.url||'',
        p.sizeGuide.contentHtml||''
      ].join(' ').toLowerCase();

      if(guideText.indexOf('dachshund')>-1)return false;
      if(guideText.indexOf('hoodie')>-1)return false;
      if(guideText.indexOf('jumper')>-1)return false;
      if(guideText.indexOf('adult')>-1)return false;
      if(guideText.indexOf('kids')>-1)return false;
      if(guideText.indexOf('toddler')>-1)return false;

      return guideText.indexOf('dog coat')>-1||
        guideText.indexOf('dog robe')>-1||
        guideText.indexOf('drying coat')>-1||
        guideText.indexOf('drying robe')>-1||
        guideText.indexOf('dog_coat_size_guide')>-1||
        guideText.indexOf('dog-coat-size-guide')>-1||
        guideText.indexOf('dog coat size guide')>-1||
        guideText.indexOf('size-guide-for-dog-robe')>-1||
        guideText.indexOf('dog-robe-image')>-1||
        guideText.indexOf('dog_coat_size_guide.webp')>-1;
    }

    function calculateBuilderSize(){
      var overlay=root.querySelector('[data-gbb-size-guide-overlay]');

      if(!overlay)return;

      var input=overlay.querySelector('[data-gbb-size-guide-input]');
      var result=overlay.querySelector('[data-gbb-size-guide-result]');
      var length=parseFloat(input&&input.value);

      if(!length){
        toast('Please enter your dog’s length in cm.');
        return;
      }

      var size='';
      var range='';
      var note='';

      if(length<18){
        size='Too Small';
        range='Less than 18cm';
      }else if(length<=23){
        size='XXS';
        range='Fits 18–23cm';
        note='This size is for the tiniest teacup dogs under 3kg. If they are a little bigger, XS is usually safer.';
      }else if(length<=28){
        size='XS';
        range='Fits 23–28cm';
      }else if(length<=35){
        size='S';
        range='Fits 28–35cm';
      }else if(length<=44){
        size='M';
        range='Fits 35–44cm';
      }else if(length<=50){
        size='L';
        range='Fits 44–50cm';
      }else if(length<=56){
        size='XL';
        range='Fits 50–56cm';
      }else if(length<=64){
        size='XXL';
        range='Fits 56–64cm';
      }else if(length<=72){
        size='3XL';
        range='Fits 64–72cm';
      }else if(length<=82){
        size='4XL';
        range='Fits 72–82cm';
      }else{
        size='Over 4XL';
        range='Needs custom fit';
      }

      result.hidden=false;
      result.innerHTML=
        '<div class="gbb__size-result-label">Recommended Size</div>'+
        '<div class="gbb__size-result-size">'+esc(size)+'</div>'+
        '<div class="gbb__size-result-range">'+esc(range)+'</div>'+
        (note?'<div class="gbb__size-result-note">'+esc(note)+'</div>':'');
    }

    function addSimple(p,g){
      var v=firstVar(p);

      if(!v||settings.trackInventory&&!available(v)){
        toast(copy.noMoreStock||'No More Stock');
        return;
      }

      addLine(p,v,g,1);
      render();
    }

    function addModal(){
  var p=state.modal.product;
  var v=selectedVar(p);
  var group=state.modal.group;
  var qty=state.modal.qty;

  if(!v||settings.trackInventory&&!available(v)){
    toast('Please select an available option');
    return;
  }

  addLine(p,v,group,qty);

  /*
    Update only the parts that changed.
    Do not rebuild the full product or card screen.
  */
  refreshVisibleBuilderButtons();
  renderTray();
  updateTrayNextButton();
   saveState();

  /*
    Close immediately without using browser history.
    Then convert the current modal history entry back
    into the normal builder step.
  */
  closeModal(true);
  replaceBuilderHistory(false);
}

function refreshVisibleBuilderButtons(){
  root.querySelectorAll(
    '[data-gbb-action][data-gbb-product]'
  ).forEach(function(button){
    var group=button.dataset.gbbAction;
    var p=find(button.dataset.gbbProduct,group);

    if(!p)return;

    var v=firstVar(p);

    var disabled=
      settings.trackInventory&&
      !productHasAvailableVariant(p);

    var selected=state.lines.some(function(line){
      return (
        line.group===group&&
        line.productId===p.id
      );
    });

    var selectedText=copy.added||'Added';
    var groupKey=String(group||'').toLowerCase();

    if(selected){
      if(groupKey.indexOf('product')>-1){
        selectedText='Add Another';
      }else if(
        groupKey.indexOf('box')>-1||
        groupKey.indexOf('card')>-1
      ){
        selectedText='✓ Selected';
      }
    }

    var text=disabled
      ? (copy.noMoreStock||'No More Stock')
      : (
          selected
            ? selectedText
            : (
                hasOptions(p)
                  ? (copy.chooseOptions||'Choose Options')
                  : (copy.addToBox||'Add To Box')
              )
        );

    button.disabled=disabled;
    button.textContent=text;
  });
}

    function addLine(p,v,g,qty){
      if(g==='box'){
        state.lines=state.lines.filter(function(l){
          return l.group!=='box';
        });
      }

      if(g==='card'){
        state.lines=state.lines.filter(function(l){
          return l.group!=='card';
        });
      }

      var key=g+':'+v.id;
      var ex=state.lines.find(function(l){
        return l.key===key;
      });

      if(ex&&g!=='box'&&g!=='card'){
        ex.qty+=qty;
        return;
      }

      state.lines.push({
        key:key,
        group:g,
        productId:p.id,
        variantId:v.id,
        title:p.title,
        variantTitle:cleanVariant(v.title),
        price:+v.price,
        image:v.image||p.featuredImage||'',
        qty:qty
      });
    }

    function forward(){
      if(!canForward(false))return;

      if(state.step===3){
        state.review=true;
      }else{
        state.step++;
      }

      resetSearch();
      pushBuilderHistory(false);
      render();
      top();
    }

    function back(){
      var currentHistory=
        window.history&&window.history.state
          ? window.history.state
          : {};

      if(
        currentHistory.gbbKey===historyStateKey&&
        (state.review||state.step>0)
      ){
        window.history.back();
        return;
      }

      if(state.review){
        state.review=false;
        state.step=3;
      }else{
        state.step=Math.max(0,state.step-1);
      }

      resetSearch();
      replaceBuilderHistory(false);
      render();
      top();
    }

    function builderHistoryState(modalOpen){
      var current=
        window.history&&window.history.state
          ? window.history.state
          : {};

      return Object.assign({},current,{
        gbbKey:historyStateKey,
        gbbStep:state.step,
        gbbReview:state.review,
        gbbModal:!!modalOpen
      });
    }

    function replaceBuilderHistory(modalOpen){
      if(!window.history||!window.history.replaceState)return;

      window.history.replaceState(
        builderHistoryState(modalOpen),
        '',
        window.location.href
      );
    }

    function pushBuilderHistory(modalOpen){
      if(!window.history||!window.history.pushState)return;

      window.history.pushState(
        builderHistoryState(modalOpen),
        '',
        window.location.href
      );
    }

    function canForward(silent){
      if(
        state.step===0&&
        !state.lines.some(function(l){
          return l.group==='box';
        })
      ){
        if(!silent){
          toast(copy.selectGiftBoxWarning||'Add at least 1 product on this step');
        }

        return false;
      }

      if(
        state.step===1&&
        !state.lines.some(function(l){
          return l.group==='product';
        })
      ){
        if(!silent){
          toast(copy.selectProductWarning||'Add at least 1 product on this step');
        }

        return false;
      }

      if(
        state.step===3&&
        !String(state.message.body||'').trim()&&
        !state.messageBlankConfirmed
      ){
        if(!silent){
          var wrap=root.querySelector('[data-gbb-blank-wrap]');
          if(wrap){
            wrap.hidden=false;
            wrap.style.borderColor='var(--gbb-orange)';
          }

          toast('Add a gift message or tick "Leave gift message blank" to continue.');

          var checkbox=root.querySelector('[data-gbb-blank-message]');
          if(checkbox){
            checkbox.focus();
          }
        }

        return false;
      }

      return true;
    }

    async function addToCart(){
      if(cartEditing)return;

      if(state.submittedInCart&&state.submittedBundleId){
        location.href='/cart';
        return;
      }

      if(cartSubmitting)return;
      if(!canForward(false))return;

      var lines=cartLines();
      var unavailableLine=lines.find(function(line){
        var product=find(line.productId,line.group);
        var variant=
          product&&product.variants
            ? product.variants.find(function(candidate){
                return +candidate.id===+line.variantId;
              })
            : null;

        return (
          !variant||
          (
            settings.trackInventory&&
            !available(variant)
          )
        );
      });

      if(unavailableLine){
        toast(
          lineTitle(unavailableLine)+
          ' has sold out. Please choose another option.'
        );
        return;
      }

      cartSubmitting=true;

      var p=pricing();
      var bundle='gift-box-'+Date.now();
      var summary=lines.map(lineTitle).join('\n');

      var items=lines.map(function(l){
        var props={
          'Gift Box Builder':'Yes',
          'Gift Box ID':bundle
        };

        if(l.group==='box'){
          props['Gift Box Items']=summary;

          if(state.message.to){
            props.To=state.message.to;
          }

          if(state.message.from){
            props.From=state.message.from;
          }

          if(state.message.body){
            props.Message=state.message.body;
          }else if(state.messageBlankConfirmed){
            props.Message='Intentionally left blank';
          }

          if(p.percent){
            props['Gift Box Discount']=p.percent+'% applied at checkout';
          }
        }

        if(l.group==='card'&&(state.message.body||state.messageBlankConfirmed)){
          props.Message=state.message.body||'Intentionally left blank';

          if(state.message.to){
            props.To=state.message.to;
          }

          if(state.message.from){
            props.From=state.message.from;
          }
        }

        return {
          id:+l.variantId,
          quantity:+l.qty,
          properties:props
        };
      });

      window.clearTimeout(loadingDelayTimer);

      loadingDelayTimer=window.setTimeout(function(){
        loading(true);
      },400);

      try{
        var res=await fetch('/cart/add.js',{
          method:'POST',
          headers:{
            'Content-Type':'application/json',
            'Accept':'application/json'
          },
          body:JSON.stringify({items:items})
        });

        if(!res.ok){
          throw new Error(await res.text());
        }

        window.clearTimeout(loadingDelayTimer);
        loadingDelayTimer=null;

        var dest=settings.redirectTo==='checkout'?'/checkout':'/cart';
        var code=p.tier&&p.tier.code?p.tier.code:'';

        state.submittedBundleId=bundle;
        state.submittedInCart=true;
        state.step=3;
        state.review=true;
        saveState();

        location.href=settings.enableDiscountRedirect&&code
          ? '/discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent(dest)
          : dest;
      }catch(err){
        window.clearTimeout(loadingDelayTimer);
        loadingDelayTimer=null;
        cartSubmitting=false;
        loading(false);

        console.error('Gift box add to cart failed',err,{items:items});
        toast('Something went wrong adding this gift box to cart.');
      }
    }

    async function verifySubmittedBundle(){
      if(!state.submittedBundleId){
        state.submittedInCart=false;
        return;
      }

      try{
        var res=await fetch('/cart.js',{
          method:'GET',
          headers:{
            'Accept':'application/json'
          },
          cache:'no-store'
        });

        if(!res.ok){
          throw new Error(await res.text());
        }

        var cart=await res.json();

        var exists=(cart.items||[]).some(function(item){
          var props=item&&item.properties?item.properties:{};

          return String(props['Gift Box ID']||'')===
            String(state.submittedBundleId);
        });

        state.submittedInCart=exists;

        if(exists){
          state.step=3;
          state.review=true;
        }else{
          state.submittedBundleId='';
        }

        replaceBuilderHistory(false);
        render();

        if(exists){
          top();
        }
      }catch(err){
        console.warn('Gift box cart check failed',err);

        /*
          Keep the saved cart lock if Shopify cannot
          currently be checked.
        */
        if(state.submittedBundleId){
          state.submittedInCart=true;
          state.step=3;
          state.review=true;
          replaceBuilderHistory(false);
          render();
        }
      }
    }

    async function editSubmittedBundle(){
      if(cartEditing)return;

      if(!state.submittedBundleId){
        state.submittedInCart=false;
        state.review=false;
        state.step=1;
        replaceBuilderHistory(false);
        render();
        top();
        return;
      }

      var confirmed=window.confirm(
        'Edit this gift box?\n\n'+
        'It will be temporarily removed from your cart while you make changes. '+
        'Your current selections and message will stay saved in the builder.'
      );

      if(!confirmed)return;

      cartEditing=true;
      render();

      try{
        var cartRes=await fetch('/cart.js',{
          method:'GET',
          headers:{
            'Accept':'application/json'
          },
          cache:'no-store'
        });

        if(!cartRes.ok){
          throw new Error(await cartRes.text());
        }

        var cart=await cartRes.json();

        var matching=(cart.items||[]).filter(function(item){
          var props=item&&item.properties?item.properties:{};

          return String(props['Gift Box ID']||'')===
            String(state.submittedBundleId);
        });

        if(!matching.length){
          state.submittedBundleId='';
          state.submittedInCart=false;
          state.review=false;
          state.step=1;
          cartEditing=false;
          saveState();
          replaceBuilderHistory(false);
          render();
          top();
          toast('This gift box was no longer in the cart. You can edit it now.');
          return;
        }

        var updates={};

        matching.forEach(function(item){
          if(item&&item.key){
            updates[String(item.key)]=0;
          }
        });

        if(!Object.keys(updates).length){
          throw new Error(
            'Matching gift box lines did not include cart line keys.'
          );
        }

        var updateRes=await fetch('/cart/update.js',{
          method:'POST',
          headers:{
            'Content-Type':'application/json',
            'Accept':'application/json'
          },
          body:JSON.stringify({
            updates:updates
          })
        });

        if(!updateRes.ok){
          throw new Error(await updateRes.text());
        }

        var updatedCart=await updateRes.json();

        var stillExists=(updatedCart.items||[]).some(function(item){
          var props=item&&item.properties?item.properties:{};

          return String(props['Gift Box ID']||'')===
            String(state.submittedBundleId);
        });

        if(stillExists){
          throw new Error(
            'The matching gift box lines were not removed from the cart.'
          );
        }

        state.submittedBundleId='';
        state.submittedInCart=false;
        state.review=false;
        state.step=1;
        cartEditing=false;
        resetSearch();
        saveState();
        replaceBuilderHistory(false);
        render();
        top();
        toast('Gift box removed from the cart. Make your changes, then add it again.');
      }catch(err){
        cartEditing=false;
        render();
        console.error('Gift box edit could not start',err);
        toast('We could not prepare this gift box for editing. It is still safely in your cart.');
      }
    }

    function loading(on){
      if(!n.loading)return;

      n.loading.classList.toggle('is-open',on);
      n.loading.setAttribute('aria-hidden',on?'false':'true');

      if(n.loadingLabel){
        n.loadingLabel.textContent='Preparing your gift...';
      }

      if(!on){
        stopLoadingAnimation();
        return;
      }

      startLoadingAnimation();
    }

    function startLoadingAnimation(){
      stopLoadingAnimation();

      if(!n.loadingVisual)return;

      if(!preparingFrames.length){
        n.loadingVisual.innerHTML=settings.preparingImage
          ? '<img src="'+attr(settings.preparingImage)+'" alt="">'
          : '<div class="gbb__box-loader"></div>';

        return;
      }

      var reducedMotion=
        window.matchMedia&&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var firstFrame=reducedMotion
        ? preparingFrames[preparingFrames.length-1]
        : preparingFrames[0];

      n.loadingVisual.innerHTML=
        '<img class="gbb__loading-frame" '+
        'data-gbb-loading-frame '+
        'src="'+attr(firstFrame)+'" '+
        'alt="">';

      if(reducedMotion)return;

      var frame=n.loadingVisual.querySelector('[data-gbb-loading-frame]');
      var sequenceIndex=0;

      loadingTimer=window.setInterval(function(){
        if(!n.loading.classList.contains('is-open')){
          stopLoadingAnimation();
          return;
        }

        sequenceIndex=(sequenceIndex+1)%loadingSequence.length;

        var frameIndex=loadingSequence[sequenceIndex];

        frame.src=
          preparingFrames[frameIndex]||
          preparingFrames[0];
      },130);
    }

    function stopLoadingAnimation(){
      if(loadingTimer){
        window.clearInterval(loadingTimer);
        loadingTimer=null;
      }
    }

    function reset(){
      clearSavedState();

      state.step=0;
      state.review=false;
      state.lines=[];
      state.message={
        to:'',
        from:'',
        body:''
      };
      state.messageBlankConfirmed=false;
      state.submittedBundleId='';
      state.submittedInCart=false;
      cartSubmitting=false;
      cartEditing=false;
      resetSearch();
      replaceBuilderHistory(false);
      render();
      top();
    }

    function loadSavedState(){
      try{
        var raw=
          window.localStorage&&
          window.localStorage.getItem(storageKey);

        if(!raw)return;

        var saved=JSON.parse(raw);

        if(
          !saved||
          !saved.savedAt||
          Date.now()-saved.savedAt>storageMaxAge
        ){
          clearSavedState();
          return;
        }

        var savedState=saved.state||{};

        state.step=Math.max(
          0,
          Math.min(3,+savedState.step||0)
        );

        state.review=!!savedState.review;

        state.lines=Array.isArray(savedState.lines)
          ? savedState.lines.map(cleanSavedLine).filter(Boolean)
          : [];

        state.message={
          to:
            savedState.message&&savedState.message.to
              ? String(savedState.message.to)
              : '',
          from:
            savedState.message&&savedState.message.from
              ? String(savedState.message.from)
              : '',
          body:
            savedState.message&&savedState.message.body
              ? String(savedState.message.body)
              : ''
        };

        state.messageBlankConfirmed=
          !String(state.message.body||'').trim()&&
          !!savedState.messageBlankConfirmed;

        state.submittedBundleId=savedState.submittedBundleId
          ? String(savedState.submittedBundleId)
          : '';

        state.submittedInCart=
          !!savedState.submittedInCart&&
          !!state.submittedBundleId;

        if(state.submittedInCart){
          state.step=3;
          state.review=true;
        }

        if(
          !state.lines.some(function(l){
            return l.group==='box';
          })
        ){
          state.step=0;
          state.review=false;
        }

        if(
          (state.step>1||state.review)&&
          !state.lines.some(function(l){
            return l.group==='product';
          })
        ){
          state.step=1;
          state.review=false;
        }
      }catch(e){
        console.warn(
          'Gift box builder saved state could not be loaded',
          e
        );

        clearSavedState();
      }
    }

    function cleanSavedLine(line){
      if(!line||!line.group||!line.variantId)return null;

      if(['box','product','card'].indexOf(line.group)===-1){
        return null;
      }

      return {
        key:String(line.key||line.group+':'+line.variantId),
        group:line.group,
        productId:+line.productId||0,
        variantId:+line.variantId,
        title:String(line.title||''),
        variantTitle:String(line.variantTitle||''),
        price:+line.price||0,
        image:String(line.image||''),
        qty:Math.max(1,+line.qty||1)
      };
    }

    function saveState(){
      try{
        if(!window.localStorage)return;

        window.localStorage.setItem(
          storageKey,
          JSON.stringify({
            savedAt:Date.now(),
            state:{
              step:state.step,
              review:state.review,
              lines:state.lines,
              message:state.message,
              messageBlankConfirmed:state.messageBlankConfirmed,
              submittedBundleId:state.submittedBundleId,
              submittedInCart:state.submittedInCart
            }
          })
        );
      }catch(e){}
    }

    function clearSavedState(){
      try{
        if(window.localStorage){
          window.localStorage.removeItem(storageKey);
        }
      }catch(e){}
    }

    function resetSearch(){
      state.search='';
      // On the card step, start with the occasion chosen on the landing page.
      // This remains a normal dropdown: shoppers can select All occasions.
      state.filter=(state.step===2&&entryOccasion)?entryOccasion:'All';
      state.sort='featured';
    }

    function prep(items){
      var out=items.filter(function(p){
        var matchesFilter=true;

        if(state.filter!=='All'){
          if(state.step===2){
            matchesFilter=cardOccasionsForProduct(p).some(function(o){
              return normalizeOccasion(o)===
                normalizeOccasion(state.filter);
            });
          }else if(state.step===1){
            matchesFilter=productMatchesType(p,state.filter);
          }else{
            matchesFilter=p.category===state.filter;
          }
        }

        return matchesFilter;
      });

      if(state.sort==='az'){
        out.sort(function(a,b){
          return a.title.localeCompare(b.title);
        });
      }

      if(state.sort==='za'){
        out.sort(function(a,b){
          return b.title.localeCompare(a.title);
        });
      }

      if(state.sort==='price-low'){
        out.sort(function(a,b){
          return a.price-b.price;
        });
      }

      if(state.sort==='price-high'){
        out.sort(function(a,b){
          return b.price-a.price;
        });
      }

      return out;
    }

    function cardOccasionsForProduct(p){
      var found=[];

      function add(label){
        label=String(label||'').trim();

        if(label&&found.indexOf(label)===-1){
          found.push(label);
        }
      }

      function cleanTag(tag){
        return String(tag||'')
          .toLowerCase()
          .trim()
          .replace(/^occasion:/,'')
          .replace(/[_-]+/g,' ')
          .replace(/\s+/g,' ');
      }

      var tagMap={
        'thank you':'Thank you',
        'thanks':'Thank you',
        'seasons greetings':'Seasons Greetings',
        'season greetings':'Seasons Greetings',
        'retirement':'Retirement',
        'retired':'Retirement',
        'new dog':'New dog',
        'new puppy':'New dog',
        'puppy':'New dog',
        'mum':'Mum',
        'mother':'Mum',
        'mom':'Mum',
        'miss you':'Miss you',
        'love you':'Love you',
        'i love you':'Love you',
        'just because':'Just because',
        'im sorry':"I'm sorry",
        "i'm sorry":"I'm sorry",
        'sorry':"I'm sorry",
        'holidays':'Holidays',
        'holiday':'Holidays',
        'good luck':'Good luck',
        'get well soon':'Get well soon',
        'get well':'Get well soon',
        'father':'Dad',
        'dad':'Dad',
        'easter':'Easter',
        'congratulations':'Congratulations',
        'congrats':'Congratulations',
        'christmas':'Christmas',
        'xmas':'Christmas',
        'birthday':'Birthday',
        'barkday':'Birthday',
        'anniversary':'Anniversary'
      };

      (p.tags||[]).forEach(function(tag){
        var cleaned=cleanTag(tag);

        if(tagMap[cleaned]){
          add(tagMap[cleaned]);
        }
      });

      (p.occasion||[]).forEach(function(o){
        var cleaned=cleanTag(o);

        if(tagMap[cleaned]){
          add(tagMap[cleaned]);
        }
      });

      return found;
    }

    function productTypeFor(p){
      var tags=(p.tags||[]).map(function(tag){
        return String(tag||'')
          .toLowerCase()
          .trim()
          .replace(/^builder:/,'')
          .replace(/&amp;/g,'and')
          .replace(/&/g,'and')
          .replace(/[_-]+/g,' ')
          .replace(/\s+/g,' ');
      });

      function hasAny(list){
        return list.some(function(value){
          value=String(value||'')
            .toLowerCase()
            .trim()
            .replace(/&amp;/g,'and')
            .replace(/&/g,'and')
            .replace(/[_-]+/g,' ')
            .replace(/\s+/g,' ');

          return tags.indexOf(value)>-1;
        });
      }

      if(hasAny(['dog towel','dog towels'])){
        return 'Dog Towels';
      }

      if(
        hasAny([
          'dog drying robe',
          'dog drying robes',
          'drying robe',
          'dog robe'
        ])
      ){
        return 'Dog Drying Robes';
      }

      if(
        hasAny([
          'dog hoodie',
          'dog hoodies',
          'dog jumper',
          'dog jumpers',
          'dog hoodie jumper',
          'dog hoodies and jumpers'
        ])
      ){
        return 'Dog Hoodies & Jumpers';
      }

      if(hasAny(['dog treats','dog treat','treats'])){
        return 'Dog Treats';
      }

      if(
        hasAny([
          'adult hooded towel',
          'adult hooded towels',
          'adult towel',
          'adult towels'
        ])
      ){
        return 'Adult Hooded Towels';
      }

      if(
        hasAny([
          'kids hooded towel',
          'kids hooded towels',
          'kid hooded towel',
          'baby hooded towel',
          'baby hooded towels',
          'toddler hooded towel',
          'toddler hooded towels'
        ])
      ){
        return 'Kids & Toddler Hooded Towels';
      }

      if(
        hasAny([
          'matching',
          'matching set',
          'matching dog owner',
          'matching dog and owner'
        ])
      ){
        return 'Matching Dog & Owner Sets';
      }

      var text=[
        p.title||'',
        p.handle||'',
        p.type||'',
        p.category||'',
        (p.tags||[]).join(' ')
      ].join(' ').toLowerCase();

      if(
        text.indexOf('treat')>-1||
        text.indexOf('sardine')>-1||
        text.indexOf('mackerel')>-1||
        text.indexOf('fish skin')>-1||
        text.indexOf('training')>-1
      ){
        return 'Dog Treats';
      }

      if(
        text.indexOf('hoodie')>-1||
        text.indexOf('jumper')>-1
      ){
        return 'Dog Hoodies & Jumpers';
      }

      if(
        text.indexOf('adult')>-1||
        text.indexOf('changing robe')>-1||
        text.indexOf('beach poncho')>-1||
        text.indexOf('adult hooded')>-1
      ){
        return 'Adult Hooded Towels';
      }

      if(
        text.indexOf('kids')>-1||
        text.indexOf('kid ')>-1||
        text.indexOf('toddler')>-1||
        text.indexOf('baby')>-1||
        text.indexOf('child')>-1
      ){
        return 'Kids & Toddler Hooded Towels';
      }

      if(
        text.indexOf('drying robe')>-1||
        text.indexOf('dog robe')>-1||
        text.indexOf('dog drying coat')>-1||
        text.indexOf('drying coat')>-1||
        text.indexOf('dachshund')>-1||
        text.indexOf('dog coat')>-1
      ){
        return 'Dog Drying Robes';
      }

      if(
        text.indexOf('dog towel')>-1||
        text.indexOf('chamois')>-1||
        text.indexOf('shammy')>-1||
        text.indexOf('noodle towel')>-1||
        text.indexOf('microfibre towel')>-1||
        text.indexOf('microfiber towel')>-1
      ){
        return 'Dog Towels';
      }

      if(
        text.indexOf('matching')>-1&&
        (
          text.indexOf('owner')>-1||
          text.indexOf('human')>-1||
          text.indexOf('set')>-1
        )
      ){
        return 'Matching Dog & Owner Sets';
      }

      return 'All';
    }

    function productTypesFor(p){
      var types=[];
      var primaryType=productTypeFor(p);

      if(primaryType&&primaryType!=='All'){
        types.push(primaryType);
      }

      var tags=(p.tags||[]).map(function(tag){
        return String(tag||'')
          .toLowerCase()
          .trim()
          .replace(/^builder:/,'')
          .replace(/&amp;/g,'and')
          .replace(/&/g,'and')
          .replace(/[_-]+/g,' ')
          .replace(/\s+/g,' ');
      });

      var text=[
        p.title||'',
        p.handle||'',
        p.type||'',
        p.category||'',
        (p.tags||[]).join(' ')
      ].join(' ').toLowerCase();

      var isMatching=
        tags.indexOf('matching')>-1||
        tags.indexOf('matching set')>-1||
        tags.indexOf('matching dog owner')>-1||
        tags.indexOf('matching dog and owner')>-1||
        (
          text.indexOf('matching')>-1&&
          (
            text.indexOf('owner')>-1||
            text.indexOf('human')>-1||
            text.indexOf('set')>-1
          )
        );

      if(
        isMatching&&
        types.indexOf('Matching Dog & Owner Sets')===-1
      ){
        types.push('Matching Dog & Owner Sets');
      }

      if(!types.length){
        types.push('All');
      }

      return types;
    }

    function productMatchesType(p,type){
      if(!type||type==='All'){
        return true;
      }

      return productTypesFor(p).indexOf(type)>-1;
    }

    function categories(items){
      var values=[];

      if(state.step===2){
        return ['All'].concat(cardOccasions());
      }

      items.forEach(function(p){
        var c=p.category||'Products';

        if(values.indexOf(c)===-1){
          values.push(c);
        }
      });

      return ['All'].concat(values);
    }

    function cardOccasions(){
      return [
        'Anniversary',
        'Birthday',
        'Christmas',
        'Congratulations',
        'Dad',
        'Easter',
        'Get well soon',
        'Good luck',
        'Holidays',
        "I'm sorry",
        'Just because',
        'Love you',
        'Miss you',
        'Mum',
        'New dog',
        'Retirement',
        'Seasons Greetings',
        'Thank you'
      ];
    }

    function normalizeOccasion(v){
      v=String(v||'').toLowerCase().trim();

      v=v.replace(/&amp;/g,'and');
      v=v.replace(/&/g,'and');
      v=v.replace(/[_-]+/g,' ');
      v=v.replace(/\s+/g,' ');

      if(v==='father')return 'dad';
      if(v==='mother')return 'mum';
      if(v==='mom')return 'mum';
      if(v==='i love you')return 'love you';
      if(v==='xmas')return 'christmas';
      if(v==='holiday')return 'holidays';
      if(v==='season greetings')return 'seasons greetings';
      if(v==="i'm sorry")return 'im sorry';

      return v;
    }

    function find(id,g){
      id=+id;

      if(g==='box'){
        return catalog.box&&catalog.box.id===id
          ? catalog.box
          : null;
      }

      return (
        g==='card'
          ? catalog.cards
          : catalog.products
      ).find(function(p){
        return p.id===id;
      });
    }

    function cartLines(){
      var order={
        box:0,
        product:1,
        card:2
      };

      return state.lines.slice().sort(function(a,b){
        return order[a.group]-order[b.group];
      });
    }

    function pricing(){
      var sub=state.lines.reduce(function(s,l){
        return s+l.price*l.qty;
      },0);

      var elig=state.lines.reduce(function(s,l){
        var group=(l.group||'').toString().toLowerCase();

        if(
          group.indexOf('box')>-1&&
          !settings.discountIncludeBox
        ){
          return s;
        }

        if(
          group.indexOf('card')>-1&&
          !settings.discountIncludeCards
        ){
          return s;
        }

        return s+l.price*l.qty;
      },0);

      var tier=tiers.slice().reverse().find(function(t){
        return elig>=t.threshold;
      });

      var percent=tier?+tier.percent:0;
      var disc=Math.round(elig*percent/100);

      return {
        subtotal:sub,
        eligible:elig,
        tier:tier,
        percent:percent,
        discount:disc,
        total:Math.max(0,sub-disc)
      };
    }

    function discountMsg(elig){
      var next=tiers.find(function(t){
        return elig<t.threshold;
      });

      if(!next&&tiers.length){
        return tiers[tiers.length-1].percent+
          '% off unlocked.';
      }

      if(!next)return '';

      if(elig<=0){
        return 'Add gifts to unlock '+
          next.percent+
          '% off.';
      }

      return 'Spend '+
        fmt(next.threshold-elig)+
        ' more on gifts to unlock '+
        next.percent+
        '% off.';
    }

    function progress(elig){
      if(!tiers.length)return 0;

      return Math.max(
        0,
        Math.min(
          100,
          Math.round(
            elig/
            tiers[tiers.length-1].threshold*
            100
          )
        )
      );
    }

    function hasOptions(p){
      if(!p.variants||p.variants.length>1)return true;

      return p.options.some(function(o){
        return !defaultOpt(o);
      });
    }

    function defaultOpt(o){
      return !o||(
        String(o.name).toLowerCase()==='title'&&
        o.values.length===1&&
        String(o.values[0]).toLowerCase()==='default title'
      );
    }

    function firstVar(p){
      return p&&p.variants
        ? (p.variants.find(available)||p.variants[0])
        : null;
    }

    function optionEntries(p){
      return (
        p&&Array.isArray(p.options)
          ? p.options
          : []
      ).map(function(option,index){
        return {
          option:option,
          index:index
        };
      }).filter(function(entry){
        return !defaultOpt(entry.option);
      });
    }

    function modalOptionValues(p,v){
      return optionEntries(p).map(function(entry){
        return (
          v&&Array.isArray(v.options)
            ? v.options[entry.index]||''
            : ''
        );
      });
    }

    function selectedVar(p){
      if(!p)return null;
      if(!hasOptions(p))return firstVar(p);

      var entries=optionEntries(p);

      return p.variants.find(function(v){
        return entries.every(function(entry,i){
          return (
            v.options[entry.index]===
            state.modal.options[i]
          );
        });
      })||null;
    }

    function optionValueAvailable(p,visibleIndex,value){
      if(!settings.trackInventory){
        return true;
      }

      var entries=optionEntries(p);
      var target=entries[visibleIndex];

      if(!target)return false;

      return p.variants.some(function(v){
        if(
          !available(v)||
          v.options[target.index]!==value
        ){
          return false;
        }

        return entries.every(function(entry,i){
          if(i===visibleIndex){
            return true;
          }

          var selected=state.modal.options[i];

          return (
            !selected||
            v.options[entry.index]===selected
          );
        });
      });
    }

    function productHasAvailableVariant(p){
      return !!(
        p&&
        Array.isArray(p.variants)&&
        p.variants.some(available)
      );
    }

    function available(v){
      return v&&v.available!==false;
    }

    function modalImages(p,v){
      var arr=[];

      if(v&&v.image){
        arr.push(v.image);
      }

      (p.images||[]).forEach(function(x){
        if(x&&!arr.includes(x)){
          arr.push(x);
        }
      });

      if(
        p.featuredImage&&
        !arr.includes(p.featuredImage)
      ){
        arr.unshift(p.featuredImage);
      }

      return arr;
    }

    function lineTitle(l){
      return l.variantTitle
        ? l.title+' - '+l.variantTitle
        : l.title;
    }

    function cleanVariant(t){
      return (
        !t||
        String(t).toLowerCase()==='default title'
      )
        ? ''
        : t;
    }

    function img(l,cls){
      return l&&l.image
        ? '<img class="'+attr(cls||'')+'" src="'+attr(l.image)+'" alt="'+attr(l.title)+'" loading="lazy">'
        : '<div class="gbb__fallback '+attr(cls||'')+'">DD</div>';
    }

    function empty(){
      return '<div class="gbb__empty">'+
        esc(copy.noProducts||'No Products Available')+
      '</div>';
    }

    function fmt(c){
      return money.format((+c||0)/100);
    }

    function toast(msg){
      n.toast.textContent=msg;
      n.toast.classList.add('is-visible');

      clearTimeout(toast.t);

      toast.t=setTimeout(function(){
        n.toast.classList.remove('is-visible');
      },2600);
    }

    function top(){
      window.scrollTo({
        top:Math.max(
          0,
          root.getBoundingClientRect().top+
          scrollY-
          120
        ),
        behavior:'smooth'
      });
    }

    function trunc(v,l){
      v=String(v||'');

      return v.length>l
        ? v.slice(0,l-1)+'…'
        : v;
    }

    function norm(p){
      if(!p||!p.id)return null;

      p.id=+p.id;
      p.handle=p.handle||'';
      p.url=p.url||'';
      p.type=p.type||'';
      p.category=p.category||'';
      p.description=p.description||'';
      p.descriptionHtml=p.descriptionHtml||'';
      p.builderDescriptionHtml=p.builderDescriptionHtml||'';
      p.tags=Array.isArray(p.tags)
        ? p.tags.filter(Boolean)
        : [];

      if(Array.isArray(p.occasion)){
        p.occasion=p.occasion.filter(Boolean).map(function(x){
          return String(x);
        });
      }else if(p.occasion){
        p.occasion=[String(p.occasion)];
      }else{
        p.occasion=[];
      }

      p.sizeGuide=
        p.sizeGuide&&p.sizeGuide.contentHtml
          ? p.sizeGuide
          : null;

      p.price=+p.price||0;
      p.images=Array.isArray(p.images)
        ? p.images.filter(Boolean)
        : [];

      p.options=Array.isArray(p.options)
        ? p.options
        : [];

      p.variants=(
        Array.isArray(p.variants)
          ? p.variants
          : []
      ).map(function(v){
        return {
          id:+v.id,
          title:v.title||'',
          available:v.available!==false,
          price:+v.price||0,
          compareAt:
            v.compareAt===null
              ? null
              : +v.compareAt||0,
          options:Array.isArray(v.options)
            ? v.options
            : [],
          image:v.image||null
        };
      });

      return p;
    }

    function esc(v){
      return String(v||'')
        .replace(/&/g,'&amp;')
        .replace(/</g,'&lt;')
        .replace(/>/g,'&gt;')
        .replace(/"/g,'&quot;')
        .replace(/'/g,'&#039;');
    }

    function attr(v){
      return esc(v).replace(/`/g,'&#096;');
    }
  });
})();